/**
 * True when a router URL is inside the HBC Go shell (`/{tenantId}/hbc-go/...`).
 *
 * Single source for the URL-shape check: reused main-HBC components branch on
 * this to adapt behaviour when rendered inside HBC Go, instead of scattering
 * the `'/hbc-go'` literal across the codebase.
 */
export function isHbcGoUrl(url: string): boolean {
  return (url || '').includes('/hbc-go');
}
